import script from "./NewParadigm.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewParadigm.vue?vue&type=script&setup=true&lang=ts"

import "./NewParadigm.vue?vue&type=style&index=0&id=5a7cf3aa&lang=css"

const __exports__ = script;

export default __exports__